var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookedOutcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12815 1C4.42554 1 4.66661 1.24108 4.66661 1.53846V2.4359H9.33328V1.53846C9.33328 1.24108 9.57436 1 9.87174 1C10.1691 1 10.4102 1.24108 10.4102 1.53846V2.4359H11.3076C12.398 2.4359 13.282 3.31985 13.282 4.41026V13.0256C13.282 14.116 12.398 15 11.3076 15H2.69225C1.60185 15 0.717896 14.116 0.717896 13.0256V4.41026C0.717896 3.31985 1.60185 2.4359 2.69225 2.4359H3.58969V1.53846C3.58969 1.24108 3.83077 1 4.12815 1ZM3.58969 3.51282H2.69225C2.19661 3.51282 1.79482 3.91462 1.79482 4.41026V6.74359H12.2051V4.41026C12.2051 3.91462 11.8033 3.51282 11.3076 3.51282H10.4102V4.41026C10.4102 4.70764 10.1691 4.94872 9.87174 4.94872C9.57436 4.94872 9.33328 4.70764 9.33328 4.41026V3.51282H4.66661V4.41026C4.66661 4.70764 4.42554 4.94872 4.12815 4.94872C3.83077 4.94872 3.58969 4.70764 3.58969 4.41026V3.51282ZM12.2051 7.82051H1.79482V13.0256C1.79482 13.5213 2.19661 13.9231 2.69225 13.9231H11.3076C11.8033 13.9231 12.2051 13.5213 12.2051 13.0256V7.82051ZM5.02559 10.8718C5.02559 10.5744 5.26666 10.3333 5.56405 10.3333H8.43584C8.73323 10.3333 8.97431 10.5744 8.97431 10.8718C8.97431 11.1692 8.73323 11.4103 8.43584 11.4103H5.56405C5.26666 11.4103 5.02559 11.1692 5.02559 10.8718Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookedOutcome);
export default __webpack_public_path__ + "static/media/booked_outcome.5d5f1ef69e93a0d078713b35fb5a9416.svg";
export { ForwardRef as ReactComponent };